export enum KpisOnboardingSteps {
  KPIS_INITIAL_STEP = 0,
  KPIS_DETAILS_PANEL_STEP = 1,
  KPIS_FILTER_STEP = 2,
}

export const KPIS_DETAIL_TOTAL_STEPS = 5;
export const KPIS_PROJECTIONS_ONBOARDING_JOURNEY_MAX_VIEWS = 3;
